import { render } from "./LoadingBookingData.vue?vue&type=template&id=38c175f4&scoped=true"
import script from "./LoadingBookingData.vue?vue&type=script&lang=js"
export * from "./LoadingBookingData.vue?vue&type=script&lang=js"

import "./LoadingBookingData.vue?vue&type=style&index=0&id=38c175f4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-38c175f4"

export default script